<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
      {{ successMessage }}
    </div>
    <b-card>
      <b-row>
        <div class="col-12 mt-16">
          <b-form @submit.prevent="addUser" v-if="show">
            <div style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;">
              <h4 style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;">
                Notification Information
              </h4>
            </div>
            <div class="row">
              <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Title:" label-for="title">
                  <div class="d-flex">
                    <b-form-input id="title" type="text" placeholder="Enter title" :state="validateField(title, 'text')" autocomplete="off" v-model="title"
                      required />
                    <div>
                      <button type="button" @click="showPickerTitle = !showPickerTitle">😀</button>
                      <Picker v-if="showPickerTitle" set="apple" @select="addEmojiInTitle"
                        :style="{ position: 'absolute', zIndex: 1000 }" />
                    </div>
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group id="input-group-2" label="Message:" label-for="message">
                  <div class="d-flex">
                    <b-form-textarea class="form-control" id="message" type="text" placeholder="Enter message" :state="validateField(message, 'text')"
                      v-model="message" required />
                    <div>
                      <button type="button" @click="showPicker = !showPicker">😀</button>
                      <Picker v-if="showPicker" set="apple" @select="addEmoji"
                        :style="{ position: 'absolute', zIndex: 1000 }" />
                    </div>
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-4 col-12">
                <b-form-group id="user-group" label="Select User:" label-for="user">
                  <MultiSelect v-model="selectedUsers" :options="userOptions" optionLabel="text" optionValue="value"
                    filter placeholder="Select User" :maxSelectedLabels="3" class="fixed-width" />
                </b-form-group>
              </div>
            </div>
            <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
              <span v-if="!isLoading">Submit</span>
              <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
  BFormTextarea,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import axios from "../../../axios";
import MultiSelect from "primevue/multiselect";
import { Picker } from 'emoji-mart-vue'

export default {
  data() {
    return {
      show: true,
      isLoading: false,
      title: "",
      message: "",
      users: [],
      selectedUsers: [],
      successMessage: "",
      userOptions: [], // Dynamic user options
      showPicker: false,
      showPickerTitle: false
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BSpinner,
    MultiSelect,
    Picker,
    BFormTextarea,
    BFormInvalidFeedback,
  },
  created() {
    this.fetchUsers();
  },
  methods: {
            validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
    fetchUsers() {
      this.type = localStorage.getItem("type");
            const endpoint = this.type === "manager" ? "managerUsersList" : "approvedAllUsersAndCompanyList";
      axios
        .get(`${endpoint}`)
        .then((response) => {
          // Map the API response to the userOptions array
          this.userOptions = response.data.data.map((user) => ({
            value: user.id, // Unique identifier
            text: user.first_name + " " + user.last_name + "  (" + user.email + ") ",
          }));
        })
        .catch((error) => {
          console.error(error);
        });
    },
    addEmoji(emoji) {
      this.message += emoji.native
      this.showPicker = false
    },

    addEmojiInTitle(emoji) {
      this.title += emoji.native
      this.showPickerTitle = false
    },
    addUser() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("title", this.title);
      formData.append("message", this.message);

      // Append each selected user's ID
      this.selectedUsers.forEach((user) => {
        formData.append("user_id[]", user);
      });
            const endpoint = this.type === "manager" ? "sendNotificationToManagerUsers" : "sendNotificationToUsers";
      axios
        .post(`${endpoint}`, formData)
        .then((response) => {
          this.$bvToast.toast("Notification sent successfully!", {
            title: "Success",
            variant: "primary",
            solid: true,
            appendToast: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$bvToast.toast("Failed to send notification. Please try again.", {
            title: "Error",
            variant: "danger",
            solid: true,
            appendToast: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.isLoading = false;
        });
    },
  },
};
</script>
<style>
.fixed-width {
  width: 100%;
  border-radius: 6px;
}
</style>
